import { useCreateQueryKeys as e } from "@maat/store-hooks";
//#region src/ai/admin/adminAiConversationQueryKeys.ts
var t = e("admin-ai-conversations", {
	list: (e, t, n) => [
		"list",
		e,
		t,
		n
	],
	detail: (e) => ["detail", e]
});
//#endregion
export { t as adminAiConversationQueryKeys };
